// Harmonia Admin API Client
// const API_BASE = 'https://harmonia.io.kr';
// const API_BASE = 'http://localhost:8080'
const API_BASE = ''

const ADMIN_API = `${API_BASE}/admin`

const api = {
  getToken() {
    return localStorage.getItem('admin_token');
  },

  setToken(token) {
    localStorage.setItem('admin_token', token);
  },

  clearToken() {
    localStorage.removeItem('admin_token');
  },

  async request(endpoint, options = {}) {
    const token = this.getToken();

    const config = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers,
      },
    };

    try {
      const res = await fetch(`${ADMIN_API}${endpoint}`, config);

      // 401 Unauthorized - redirect to login
      if (res.status === 401) {
        this.clearToken();
        window.location.href = '/login/';
        return null;
      }

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || data.error || 'API Error');
      }

      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  // ============================================================
  // Auth
  // ============================================================
  async login(email, password) {
    // login은 public 라우터에 있음 (/api/admin/login)
    const res = await fetch(`${API_BASE}/api/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Login failed');
    }
    if (data?.data?.token) {
      this.setToken(data.data.token);
    }
    return data;
  },

  logout() {
    this.clearToken();
    window.location.href = '/login/';
  },

  changePassword(currentPassword, newPassword) {
    return this.request('/password', {
      method: 'PUT',
      body: JSON.stringify({
        current_password: currentPassword,
        new_password: newPassword,
      }),
    });
  },

  // ============================================================
  // Dashboard
  // ============================================================
  getDashboard() {
    return this.request('/dashboard');
  },

  // ============================================================
  // Users
  // ============================================================
  getUsers(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/users${query ? `?${query}` : ''}`);
  },

  getUser(id) {
    return this.request(`/users/${id}`);
  },

  suspendUser(id, data) {
    return this.request(`/users/${id}/suspend`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  unsuspendUser(id) {
    return this.request(`/users/${id}/unsuspend`, {
      method: 'PUT',
    });
  },

  // ============================================================
  // Verifications
  // ============================================================
  getPendingVerifications() {
    return this.request('/verifications/pending');
  },

  reviewEducation(id, data) {
    return this.request(`/verifications/educations/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  reviewAward(id, data) {
    return this.request(`/verifications/awards/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  reviewBusinessRegistration(id, data) {
    return this.request(`/verifications/business/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  // ============================================================
  // Reports
  // ============================================================
  getReports(status = '') {
    return this.request(`/reports${status ? `?status=${status}` : ''}`);
  },

  processReport(id, data) {
    return this.request(`/reports/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  getReportTargetDetail(type, id) {
    return this.request(`/reports/target/${type}/${id}`);
  },

  deleteArtist(id) {
    return this.request(`/artists/${id}`, { method: 'DELETE' });
  },

  deletePosting(id) {
    return this.request(`/postings/${id}`, { method: 'DELETE' });
  },

  deleteReview(id) {
    return this.request(`/reviews/${id}`, { method: 'DELETE' });
  },

  // ============================================================
  // Statistics
  // ============================================================
  getSignupStats(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/stats/signups${query ? `?${query}` : ''}`);
  },

  getPostingStats(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/stats/postings${query ? `?${query}` : ''}`);
  },

  getMatchStats(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/stats/matches${query ? `?${query}` : ''}`);
  },

  // ============================================================
  // Announcements
  // ============================================================
  getAnnouncements() {
    return this.request('/announcements');
  },

  createAnnouncement(data) {
    return this.request('/announcements', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  updateAnnouncement(id, data) {
    return this.request(`/announcements/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  deleteAnnouncement(id) {
    return this.request(`/announcements/${id}`, {
      method: 'DELETE',
    });
  },

  // ============================================================
  // Promo Codes
  // ============================================================
  getPromoCodes() {
    return this.request('/promo-codes');
  },

  createPromoCode(data) {
    return this.request('/promo-codes', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  deactivatePromoCode(id) {
    return this.request(`/promo-codes/${id}/deactivate`, {
      method: 'PUT',
    });
  },

  getPromoCodeUsage(id) {
    return this.request(`/promo-codes/${id}/usage`);
  },

  grantUserBenefits(userId, data) {
    return this.request(`/users/${userId}/benefits`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
};

// Global logout function for sidebar
window.logout = function() {
  api.logout();
};

// Global notification functions for consistent error/success handling
window.showSuccess = function(message) {
  alert(message);
};

window.showError = function(message) {
  alert(message);
};

// Export for module usage
window.api = api;
export default api;
